import { useQuery } from '@tanstack/react-query';
import { getGlobalConfig } from '@dealstack/frontend/shared/globalConfig';
import { downloadFileBlob } from './downloadFileBlob';

interface DocumentDownloadResponse {
	payload: {
		downloadUrl: string;
	};
}

async function fetchPublicSigningDocument(token: string): Promise<Blob> {
	const config = getGlobalConfig();
	const url = `${config.apiUrl}/public-signing/document?token=${encodeURIComponent(token)}`;

	const response = await fetch(url);
	if (!response.ok) {
		throw new Error('Failed to fetch document');
	}

	const data: DocumentDownloadResponse = await response.json();
	return downloadFileBlob(data.payload.downloadUrl);
}

export const usePublicSigningDocument = (token: string, enabled: boolean) => {
	return useQuery({
		queryKey: ['public-signing-document', token],
		queryFn: () => fetchPublicSigningDocument(token),
		enabled: !!token && enabled,
		retry: false,
		staleTime: Infinity,
	});
};
